// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outerObstacleListDiv {
  background-color: rgb(232, 229, 229);
  padding:  40px 170px;
}

.obstacleHeading {
  text-align: center;
  font-size: 24px;
  margin-bottom: 10px; /* Adjusted to reduce the gap between the text and image */
}

.yearText {
  color: red;
}

.obstacleImageContainer {
  display: flex;
  justify-content: center;
  margin-bottom: 20px; /* Space between image and the cards */
}

.headingImage {
  width: 150px; /* Adjust the size as needed */
  height: auto;
}

.obstacleCardContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-left: 20px;
}

.obstacleCard {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 20px); /* Two cards per row, minus gap */
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
}

.obstacleImage {
  width: 100%;
  height: auto;
}

.obstacleName {
  font-size: 18px;
  margin: 10px 0 5px;
}

.obstacleDesc {
  font-size: 14px;
  margin: 0 10px 10px;
}

@media screen and (max-width: 768px) {
  .obstacleCard {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 20px); /* Full width for smaller screens */
  }

  .outerObstacleListDiv {
    background-color: rgba(210, 211, 212, 0.5);
    padding: 46px 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/obstacles/obstacleList.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB,EAAE,0DAA0D;AACjF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAE,sCAAsC;AAC7D;;AAEA;EACE,YAAY,EAAE,8BAA8B;EAC5C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,iCAAiC;EAC7D,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B,EAAE,mCAAmC;EAClE;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;AACF","sourcesContent":[".outerObstacleListDiv {\n  background-color: rgb(232, 229, 229);\n  padding:  40px 170px;\n}\n\n.obstacleHeading {\n  text-align: center;\n  font-size: 24px;\n  margin-bottom: 10px; /* Adjusted to reduce the gap between the text and image */\n}\n\n.yearText {\n  color: red;\n}\n\n.obstacleImageContainer {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px; /* Space between image and the cards */\n}\n\n.headingImage {\n  width: 150px; /* Adjust the size as needed */\n  height: auto;\n}\n\n.obstacleCardContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-left: 20px;\n}\n\n.obstacleCard {\n  flex: 0 0 calc(50% - 20px); /* Two cards per row, minus gap */\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  text-align: center;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.obstacleImage {\n  width: 100%;\n  height: auto;\n}\n\n.obstacleName {\n  font-size: 18px;\n  margin: 10px 0 5px;\n}\n\n.obstacleDesc {\n  font-size: 14px;\n  margin: 0 10px 10px;\n}\n\n@media screen and (max-width: 768px) {\n  .obstacleCard {\n    flex: 0 0 calc(100% - 20px); /* Full width for smaller screens */\n  }\n\n  .outerObstacleListDiv {\n    background-color: rgba(210, 211, 212, 0.5);\n    padding: 46px 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
